import axios from 'axios'
import settings from '@/settings.js'

const Actions = {
  uploadProgram ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      var numero = payload.numero
      var uploads = payload.uploads
      var result = []
      var count = 0
      // check for upload files
      uploads.forEach(function (element) {
        commit('status_loading')
        var formData = new FormData()
        var file = element[0]
        formData.append('file', file)
        // call the api
        axios({
          method: 'post',
          url: settings.host,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-API-Key': state.auth.key,
            Authorization: `Bearer ${state.auth.token}`
          },
          params: {
            function: 'uploadProgram',
            params: {
              program: numero,
              name: element[1],
              type: element[2]
            }
          }
        })
          .then(resp => {
            // check header status code
            if (resp.data.status.success) {
              // prepare array success
              var urlpath = resp.data.data.filename
              var tmpArray = []
              tmpArray.push(element[3])
              tmpArray.push(urlpath)
              result.push('', tmpArray)
              count++
              // success
              var mess = 'File ' + element[1] + ' uploaded!'
              commit('status_success', mess)
              if (count === uploads.length) {
                resolve(result)
              }
            } else {
              // error
              var err = 'Upload ' + element[1] + ' failed!'
              commit('status_error', err)
            }
          })
      })
    })
  },
  /*
  uploadLot ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
    // check for upload files
      commit('status_loading')
      var formData = new FormData()
      var file = payload.upload[0]
      formData.append('file', file)
      // call the api
      axios({
        method: 'post',
        url: settings.host,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-API-Key': state.auth.key,
          Authorization: `Bearer ${state.auth.token}`
        },
        params: {
          function: 'uploadLot',
          params: {
            lot: payload.lotNumero,
            program: payload.programNumero,
            name: payload.upload[1],
            type: payload.upload[2]
          }
        }
      })
        .then(resp => {
          // get file name from API
          var filename = resp.data.data.filename
          // resolve even if it does'nt work
          var result = {
            status: resp.data.status.success,
            filename: filename
          }
          resolve(result)
        })
        .catch((err) => {
          // error
          console.error(err)
          var mess = 'Upload failed!'
          commit('status_error', mess)
        })
    })
  },
  */
  uploadLot ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
    // check for upload files
      commit('status_loading')
      var program = payload.programNumero
      var lot = payload.lotNumero
      var uploads = payload.uploads
      var result = []
      var count = 0
      // check for upload files
      uploads.forEach(function (element) {
        commit('status_loading')
        var formData = new FormData()
        var file = element[0]
        formData.append('file', file)
        // call the api
        axios({
          method: 'post',
          url: settings.host,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-API-Key': state.auth.key,
            Authorization: `Bearer ${state.auth.token}`
          },
          params: {
            function: 'uploadLot',
            params: {
              lot: lot,
              program: program,
              name: element[1],
              type: element[2]
            }
          }
        })
          .then(resp => {
            // check header status code
            if (resp.data.status.success) {
              // prepare array success
              var urlpath = resp.data.data.filename
              var tmpArray = []
              tmpArray.push(element[3])
              tmpArray.push(urlpath)
              result.push('', tmpArray)
              count++
              // success
              var mess = 'File ' + element[1] + ' uploaded!'
              commit('status_success', mess)
              if (count === uploads.length) {
                resolve(result)
              }
            } else {
              // error
              var err = 'Upload ' + element[1] + ' failed!'
              commit('status_error', err)
            }
          })
      })
    })
  },
  uploadConfig ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      var uploads = payload.uploads
      var result = []
      var count = 0
      // check for upload files
      uploads.forEach(function (element) {
        commit('status_loading')
        var formData = new FormData()
        var file = element[0]
        formData.append('file', file)
        // call the api
        axios({
          method: 'post',
          url: settings.host,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-API-Key': state.auth.key,
            Authorization: `Bearer ${state.auth.token}`
          },
          params: {
            function: 'uploadConfig',
            params: {
              name: element[1],
              type: element[2]
            }
          }
        })
          .then(resp => {
            // check header status code
            if (resp.data.status.success) {
              // prepare array success
              var urlpath = resp.data.data.filename
              var tmpArray = []
              tmpArray.push(element[3])
              tmpArray.push(urlpath)
              result.push('', tmpArray)
              count++
              // success
              var mess = 'File uploaded!'
              commit('status_success', mess)
              if (count === uploads.length) {
                resolve(result)
              }
            } else {
              // error
              var err = 'Upload failed!'
              commit('status_error', err)
            }
          })
      })
    })
  }
}

export default Actions
